
<div class="dropdown" [ngClass]="{'static': isList}">
  <div class="input-group">
    <span class="input-group-addon">{{ 'offer.productsPerPage' | translate }}</span>
    <button class="btn btn-primary input-group-btn dropdown-toggle" type="button" tabindex="0">
      {{ currentLimit || (allAvailable ? ('pagination.all' | translate) : '') }}
      <i class="fa fa-caret-down"></i>
    </button>
    <ul class="menu">
      <li *ngFor="let limit of availableLimits" class="menu-item" (mousedown)="onLimitClick(limit)">
        <a>
          {{ limit }}
        </a>
      </li>
    </ul>
  </div>
</div>